/*
 * File: ErrorPage.tsx
 * Project: autofi-front
 * File Created: Thursday, 12th January 2023 02:37:11
 * Author: Simon (s.gourlet@autobuy.fr)
 * -----
 * Last Modified: Thursday, 20th April 2023 05:21:47
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright 2022 - 2023 SAS Olivier Dubois, SAS Olivier Dubois
 */

import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import NotFound from "Content/Error/NotFoundPage/NotFound";
import Unauthorized from "Content/Error/UnauthorizedPage/Unauthorized";

export default function ErrorPage() {
    const error = useRouteError();

    if (isRouteErrorResponse(error)) {
        if (error.status === 401) {
            return (<Unauthorized />)
        }
        else if (error.status === 404) {
            return (<NotFound />)
        }
        return (
            <div id="error-page">
                <h1>Oops! {error.status}</h1>
                <p>{error.statusText}</p>
                {error.data?.message && (
                    <p>
                        <i>{error.data.message}</i>
                    </p>
                )}
            </div>
    );
    } else if (error instanceof Error) {
        return (
            <div id="error-page">
                <h1>Oops! Unexpected Error</h1>
                <p>Something went wrong.</p>
                <p>
                    <i>{error.message}</i>
                </p>
            </div>
        );
    }
    return <p>I don't know what to do???</p>;
}